import SingleSlider from './_SingleSlider.js';
import { jsx } from 'react/jsx-runtime';

var formatWithThousandSeparator = function formatWithThousandSeparator(value, separator) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
var formatDistance = function formatDistance(value) {
  return "".concat(formatWithThousandSeparator(value, ' '), " m");
};
var distanceFormatterWithMaxValue = function distanceFormatterWithMaxValue(maxValue) {
  return function (value) {
    if (+value >= +maxValue) {
      return "> ".concat(formatDistance(value));
    }
    return formatDistance(value);
  };
};
var steps = [25, 50, 100, 250, 500, 750, 1000, 2000, 3000, 4000, 5000, 7500, 10000];
var DistanceSlider = function DistanceSlider(_ref) {
  var uniqueId = _ref.uniqueId,
    onChangeComplete = _ref.onChangeComplete,
    value = _ref.value,
    valueLabel = _ref.valueLabel,
    hidden = _ref.hidden;
  if (!uniqueId || !onChangeComplete || typeof onChangeComplete !== 'function') {
    return false;
  }
  var startValue = typeof value !== 'undefined' && steps.indexOf(value) >= 0 ? value : steps[steps.length - 1];
  return /*#__PURE__*/jsx(SingleSlider, {
    uniqueId: uniqueId,
    steps: steps,
    value: startValue,
    format: distanceFormatterWithMaxValue(steps[steps.length - 1]),
    valueLabel: valueLabel,
    onChangeComplete: onChangeComplete,
    hidden: hidden
  });
};
DistanceSlider.maxValue = steps[steps.length - 1];
DistanceSlider.defaultProps = {
  uniqueId: '',
  onChangeComplete: function onChangeComplete() {},
  value: 0,
  valueLabel: '',
  hidden: false
};
var DistanceSlider$1 = DistanceSlider;

export { DistanceSlider$1 as default };
//# sourceMappingURL=DistanceSlider.js.map
